export const TRAVELLER_TRIP_LENGTH = [
    { value: 1, label: '1', name: '1 day (Day Trip)' },
    { value: 4, label: '2-4', name: '2 to 4 days (Short Break)' },
    { value: 8, label: '5-8', name: '5 to 8 days (Week)' },
    { value: 11, label: '9-11', name: '9 to 11 days (Extended Week)' },
    { value: 15, label: '12-15', name: '12 to 15 days (Fortnight)' },
    { value: 16, label: '16+', name: '16+ days' },
]